import { render } from "./YourProfessionSelectionView.vue?vue&type=template&id=659266e2"
import script from "./YourProfessionSelectionView.vue?vue&type=script&lang=js"
export * from "./YourProfessionSelectionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__